<template>
  <div class="cmp-drag">
    <el-card class="box-card drag-list">
      <div slot="header" class="header clearfix">
        <h2>
          {{itemGroup.taskName}}
          <el-badge class="ml-10" :value="itemGroup.lists.length" type="info" />
        </h2>

        <el-popover class="pop-wrap" placement="bottom-start" v-model="showPopover" trigger="click">
          <div class="operate-box">
            <!-- 菜单悬浮面板 -->
            <div class="m-panel" v-if="showMenu">
              <h3 @click="handleOperate(itemGroup, 1)">修改看板名称</h3>
              <h3 @click="handleOperate(itemGroup, 2)">设置本看板所有任务负责人</h3>

              <h3>
                <el-date-picker class="cus-btn-date" @change="handleOperate(itemGroup, 3)" v-model="chooseDate" type="date" :value-format="'yyyy-MM-dd'" placeholder="设置本看板所有任务截止时间"></el-date-picker>
              </h3>
              <h3 class="m-danger dele" @click="handleOperate(itemGroup, 4)">删除看板</h3>
            </div>

            <!-- 搜索负责人列表 悬浮面板 -->
            <cmp-leader-list ref="cmpLeaderList" :itemGroup="currentItem" :callFun="handleChoose"></cmp-leader-list>
          </div>
          <span class="operate" slot="reference" @click="clickMenu">
            <i class="el-icon el-icon-more"></i>
          </span>
        </el-popover>
      </div>

      <div class="content">
        <draggable class="list-group" :list="list" :options="{group:groupA,draggable:'.candrag'}" @change="dragChange($event,currentItem)">
          <!--优先级 priority 1:普通2:紧急3:非常紧急  -->
          <!--collectStatus 1:未完成,2:已完成,3:已逾期 -->
          <div class="list-group-item candrag" :class="{'tip warning': item.priority === '2', 'tip rush': item.priority === '3'}" @click="showDetailDialog(item)" v-for="(item, index) in list" :key="index">
            <div class="group-item" :class="{'is-checked': item.collectStatus === '2'}">
              <div class="title-box">
                <div class="flex-row">
                  <label class="my-checkbox el-checkbox__input" :class="{'is-checked': item.collectStatus === '2'}" @click.stop="toggleCheck(item)">
                    <span class="el-checkbox__inner"></span>
                  </label>
                  <div>
                    <span class="my-check-title" :class="{'is-checked': item.collectStatus === '2'}">{{item.taskName}}{{item.kidsCount > 0 ? '('+item.kidCompleteNum+'/'+item.kidsCount+')' : ''}}</span>&nbsp;
                    <svg-icon icon-class="fujian" class-name="icon-add" v-if="item.relativeId" style="font-size: 16px;position:relative;top:1px;" />
                  </div>
                </div>

                <div v-if="$store.state.user.userid == item.creater" @click.stop="deleTask(item)">
                  <i class="el-dialog__close el-icon el-icon-close"></i>
                </div>
              </div>
              <div class="person-box">
                <!-- 截止时间 -->
                <div style="width:170px;height:40px;line-height:40px;">
                  <span class="btn-deadline" v-if="!item.deadline" style="position:relative;left:20px;top:-1px;line-height:40px;font-size:14px;color:#9699A2;">没有截止时间</span>

                  <div class="time" :class="{'m-danger':item.collectStatus==='3'}" style="position:absolute;left: 44px;" @click.stop>
                    <!-- <svg-icon icon-class="date" class-name="icon-item" style="margin-right:3px;"/> -->
                    <!-- <el-date-picker
                      class="cus-btn-date" style="width: 180px;"
                      v-model="item.deadline"
                      :value-format="'yyyy-MM-dd'"
                      :format="item.deadline | dateFilter('截止')"
                      @change="updateTaskDeadline(item)"
                      type="date"
                      placeholder="">
                    </el-date-picker>-->

                    <cmp-date-picker v-model="item.deadline" :filterType="'1'" :dateWidth="120" @inputChange="updateTaskDeadline(item)"></cmp-date-picker>
                  </div>
                </div>

                <!-- 负责人 -->
                <el-popover class="pop-wrap" placement="top-start" v-model="item.showLeaderPopover" trigger="click">
                  <!-- 搜索负责人列表 悬浮面板 -->
                  <cmp-leader-list ref="cmpLeaderListPanel" :itemGroup="item" :callFun="updateTaskLeader"></cmp-leader-list>
                  <span class="operate" slot="reference" @click.stop="showLeaderList(item, index)">
                    <img class="g-pic mini" :src="item.assignerImage || ''" alt :onerror="defaultHeadImg">
                    <span style="font-size: 14px">{{item.assignerName}}</span>
                  </span>
                </el-popover>
                <!-- <img class="g-pic mini fr" :src="item.assignerImage || ''" alt="" :onerror="defaultHeadImg"> -->
              </div>
            </div>
          </div>

          <!-- 添加新任务 -->
          <div slot="footer">
            <p class="panel-add m-assist mb-10" v-if="!showAddTask" @click="showAddTaskArea">
              <svg-icon icon-class="add" class-name="icon-add" />&nbsp;添加新任务
            </p>
            <!-- <div class="task-add-box" v-if="showAddTask" @click.stop="clickAddEle"> -->
            <div class="task-add-box" v-if="showAddTask">
              <el-input ref="myAddArea" class="task-area" type="textarea" v-model="form.newTask" placeholder="请输入任务标题"></el-input>
              <h4 class="btn-deadline-box">
                <el-popover class="pop-wrap" placement="top-start" v-model="addLeaderPopover" trigger="click">
                  <!-- 搜索负责人列表 悬浮面板 -->
                  <cmp-leader-list ref="cmpLeaderList1" :callFun="handleChooseAdd"></cmp-leader-list>

                  <span class="operate" slot="reference" @click="showLeaderList">
                    <svg-icon icon-class="chengyuan" class-name="icon-item icon-chengyuan" />
                    {{form.leader || '负责人'}}
                  </span>
                </el-popover>

                <!-- <span style="position:absolute;right:0;">
                  <svg-icon icon-class="date" class-name="icon-item" style="margin-right:3px;"/>
                  <el-date-picker
                    class="cus-btn-date" style="width: 130px;"
                    v-model="form.deadline"
                    :value-format="'yyyy-MM-dd'"
                    :format="form.deadline | dateFilter"
                    type="date"
                    placeholder="">
                  </el-date-picker>
                </span>-->

                <div style="position:relative;">
                  <!-- <span class="btn-deadline" v-if="!form.deadline">截止时间</span> -->
                  <span class="btn-deadline" v-if="!form.deadline" style="position:absolute;left:20px;width:100px;">没有截止时间</span>

                  <cmp-date-picker v-model="form.deadline" :iconClass="`primary`" :txtClass="`default`" :dateWidth="150" :placeholder="``"></cmp-date-picker>
                </div>
              </h4>
              <el-button class="mg-20 mb-10" type="primary" @click="submitAddTask">确定</el-button>
              <el-button class="mg-20" @click="showAddTask=false" style="margin-left:10px !important;">取消</el-button>
            </div>
          </div>
        </draggable>
      </div>
    </el-card>
  </div>
</template>

<script>
// import moment from 'moment'
import draggable from 'vuedraggable'
import cmpLeaderList from '@cmp/leader-list'
import cmpDatePicker from '@cmp/my-date/date-picker'

export default {
  name: 'DragList',
  components: { draggable, cmpLeaderList, cmpDatePicker },
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
    // 回调
    callFun: Function,
    itemGroup: Object
  },
  computed: {
    currentItem() {
      console.log(111, this.itemGroup)
      return this.itemGroup
    }
  },
  data() {
    return {
      defaultHeadImg: this.$store.state.app.defaultHeadImg,
      groupA: {
        name: "task",
        pull: true,  //可以拖出
        put: true,   //可以拖入
      },
      key: '',
      showPopover: false,
      updateLeaderPopover: false, // 修改任务负责人面板
      addLeaderPopover: false, // 添加任务负责人面板
      showMenu: true, // 显示菜单面板
      checkedList: [1, 2, 5, 9],
      chooseDate: '',
      showAddTask: false,
      formatTxt: 'yyyy年MM月dd日',
      form: {
        newTask: '', //新任务名称
        deadline: '', //截止时间
        leader: '',
        leaderId: ''
      }
      // pickerOptions: {
      //   disabledDate(time) {
      //     // const day = 1 * 24 * 3600 * 1000;
      //     // const weeks = 14 * 24 * 3600 * 1000;
      //     // const minTime = Date.now();
      //     // const maxTime = minTime + weeks;
      //     // return time.getTime() < (minTime-day) || time.getTime() > maxTime;
      //     const minTime = Date.now();
      //     return time.getTime() <= minTime
      //   }
      // },
    }
  },
  methods: {
    // 显示添加任务
    showAddTaskArea() {
      this.showAddTask = true

      this.$nextTick(() => {
        this.$refs.myAddArea.$el.querySelector('textarea').focus()
      })
    },
    // 完成任务
    toggleCheck(item) {
      this.updateProjectTask(item)
    },
    // 弹框详情
    showDetailDialog(item) {
      this.$emit('showProDialog', item)
    },
    // 删除任务
    deleTask(obj) {

      this.$common.confirm(
        {
          title: '删除任务',
          content: '该任务下所有子任务将被删除，请谨慎操作'
        },
        () => {
          this.$http
            .post('/projectTask/deleteTask', {
              taskId: obj.taskId
            })
            .then(res => {
              if (res.success) {
                this.dialogShow = false
                this.$emit('refresh')
                this.$message.success('删除任务成功')
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },
    // showDetailDialog(item) {
    //   this.$emit('showProDialog', item.taskId, this.itemGroup)
    // },
    clickMenu() {
      // 清空
      this.chooseDate = ''

      this.showMenu = true
      this.$refs.cmpLeaderList.init()
    },
    showLeaderList(item, index) {
      if (item.taskId) {
        document.querySelector('#app').click()
        this.$refs.cmpLeaderListPanel[index].showList()
        return
      }
      this.$refs.cmpLeaderList1.showList()
    },
    // 点击菜单面板
    handleOperate(item, type) {
      switch (type) {
        case 1:
          this.showPopover = false
          this.modifyPanel()
          break
        case 2:
          this.showMenu = false // 任务负责人
          this.$refs.cmpLeaderList.showList() // 负责人列表
          break
        // 设置截止时间
        case 3:
          this.showPopover = false
          this.updateTaskBoard({
            taskName: '', //	看板名称
            assigner: '', //	任务负责人
            deadline: this.chooseDate, //	任务截止时间
            taskId: this.itemGroup.taskId //	任务ID
          })
          break
        case 4:
          this.delePanel(item)
          this.showPopover = false
          break
      }
    },
    // 修改任务看板
    modifyPanel() {
      this.$prompt('', '修改看板名称', {
        showClose: true,
        showCancelButton: false,
        confirmButtonText: '确定',
        inputPlaceholder: '看板名称',
        inputValue: this.itemGroup.taskName,
        // inputPattern: /^[\S]{1,15}$/,
        inputPattern: /^.{1,15}$/,
        inputErrorMessage: '请输入1到15位字符'
        // center: true
      })
        .then(({ value }) => {
          this.updateTaskBoard({
            taskName: value, //	看板名称
            assigner: '', //	任务负责人
            deadline: '', //	任务截止时间
            taskId: this.itemGroup.taskId //	任务ID
          })
        })
        .catch(() => { })
    },
    // 删除看板
    delePanel(item) {
      this.$common.confirm(
        {
          title: '删除看板',
          content: '该看板下所有任务将被删除，请谨慎操作'
        },
        () => {
          this.$http
            .post('/projectTask/deleteTask', {
              taskId: item.taskId
            })
            .then(res => {
              if (res.success) {
                this.$emit('refresh') // 刷新父组件
                this.$message.success('删除看板成功')
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },
    // 选择本看板所有任务负责人
    handleChoose(item) {
      this.showPopover = false

      this.updateTaskBoard({
        taskName: '', //	看板名称
        assigner: item.userId, //	任务负责人
        deadline: '', //	任务截止时间
        taskId: this.itemGroup.taskId //	任务ID
      })
    },
    // 修改看板
    updateTaskBoard(params) {
      this.$http.post('/projectTask/updateTaskBoard', params).then(res => {
        if (res.success) {
          this.$message.success(res.message || '操作成功')
          this.$emit('refresh') // 刷新父组件
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 添加任务-选择任务负责人
    handleChooseAdd(item) {
      this.addLeaderPopover = false
      this.form.leader = item.userName
      this.form.leaderId = item.userId
    },
    // 修改任务-截止时间
    updateTaskDeadline(item) {
      this.sendUpdateTask({
        taskId: item.taskId,
        deadline: item.deadline,
        ext1: 'deadline' //	修改的字段名称
      })
    },
    // 修改任务-负责人
    updateTaskLeader(item, remoteData) {
      this.sendUpdateTask({
        taskId: remoteData.taskId, //	任务ID
        assigner: item.userId, //	负责人
        ext1: 'assigner' //	修改的字段名称
      })
    },
    sendUpdateTask(params) {
      this.$http.post('/projectTask/updateProjectTask', params).then(res => {
        if (res.success) {
          this.$message.success(res.message || '修改成功')
          this.$emit('refresh')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 添加新任务
    submitAddTask() {
      if (!this.form.newTask) {
        this.$message.warning('任务标题不能为空')
        return
      }
      this.$http
        .post('/projectTask/addProjectTask', {
          taskName: this.form.newTask, //	任务名称
          blockId: this.itemGroup.blockId, //	项目ID
          parentId: this.itemGroup.taskId, //	父级任务ID
          deadline: this.form.deadline, //	截止时间
          assigner: this.form.leaderId, //	负责人
          sort: this.itemGroup.lists[this.itemGroup.lists.length - 1]
            ? this.itemGroup.lists[this.itemGroup.lists.length - 1].taskId
            : '' //	排序前一个ID
        })
        .then(res => {
          if (res.success) {
            this.$message.success('添加成功')
            this.list.push(res.result)
            this.showAddTask = false
            this.form.newTask = ''
            this.form.deadline = ''
            this.form.leader = ''
            this.form.leaderId = ''
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 修改任务
    updateProjectTask(item) {
      this.$http
        .post('/projectTask/updateProjectTask', {
          taskId: item.taskId, //	任务ID
          taskName: item.taskName, //	任务名称
          collectStatus: item.collectStatus === '2' ? '1' : '2', //	任务状态((1:未完成,2:已完成,3:已延期,4:已超期)
          deadline: item.deadline, //	截止时间
          assigner: item.assigner, //	负责人
          description: item.description, //	任务描述
          priority: item.priority, //	优先级(1:普通2:紧急3:非常紧急)
          ext1: 'collectStatus' //	修改的字段名称
        })
        .then(res => {
          if (res.success) {
            this.$message.success(res.message || '操作成功')
            item.collectStatus = item.collectStatus === '2' ? '1' : '2'
          } else {
            this.$message.error(res.message)
          }
        })
    },
    dragChange(evt, itemGroup) {
      console.log(evt)
      this.$nextTick(() => {
        // 新增
        if (evt.added) {
          console.log('新增')
          console.log(evt, evt.added.newIndex, itemGroup, itemGroup.lists)
          // 解决处理快速拖动的bug
          if (
            itemGroup.lists[evt.added.newIndex - 1] &&
            itemGroup.lists[evt.added.newIndex - 1].taskId ===
            evt.added.element.taskId
          ) {
            evt.added.newIndex -= 1
          }
          this.changeList({
            taskId: evt.added.element.taskId, //	需移动任务ID
            parentId: itemGroup.taskId, //	待移动到父级Id  (看板ID)
            ext2: evt.added.newIndex - 1,
            sort: itemGroup.lists[evt.added.newIndex - 1]
              ? itemGroup.lists[evt.added.newIndex - 1].taskId
              : '' //	待移动到前一位任务ID
          })
        }
        // 移除
        // if(evt.removed) {
        // }
        // 移动
        if (evt.moved) {
          console.log('移动')
          console.log(evt, itemGroup)
          if (
            itemGroup.lists[evt.moved.newIndex - 1] &&
            itemGroup.lists[evt.moved.newIndex - 1].taskId ===
            evt.moved.element.taskId
          ) {
            evt.moved.newIndex -= 1
          }
          this.changeList({
            taskId: evt.moved.element.taskId, //	需移动任务ID
            parentId: itemGroup.taskId, //	待移动到父级Id  (看板ID)
            ext2: evt.moved.newIndex - 1,
            sort: itemGroup.lists[evt.moved.newIndex - 1]
              ? itemGroup.lists[evt.moved.newIndex - 1].taskId
              : '' //	待移动到前一位任务ID
          })
        }
      })
    },
    // 移动
    changeList(params) {
      this.$http.post('/projectTask/moveProjectTask', params).then(res => {
        if (res.success) {
          // this.$message.success('移动成功')
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },
  created() { }
  // mounted () {
  //   document.addEventListener('click', this.handleBodyClick)
  // },
  // destroyed () {
  //   document.removeEventListener('click', this.handleBodyClick)
  // }
}
</script>

<style lang="scss" scoped>
.cus-btn-date {
  ::-webkit-input-placeholder {
    /* WebKit browsers */
    color: $color6;
  }
  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: $color6;
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: $color6;
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: $color6;
  }
}
.btn-deadline-box {
  position: relative;
  display: flex;
  justify-content: space-between;
  .pop-wrap {
    margin-right: 40px;
    line-height: 40px;
  }
  .btn-deadline {
    position: absolute;
    right: 70px;
    top: 10px;
  }
}
.icon-chengyuan {
  color: $primary;
  font-size: 14px;
}
.cmp-drag {
  .drag-list {
    width: 330px;
    padding: 20px;
    padding-right: 10px;
    margin-right: 20px;
    box-sizing: border-box;
    margin-bottom: 20px;
    overflow: initial;

    .header {
      position: relative;
      padding-right: 10px;
      .pop-wrap {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 0;
        right: 10px;
        cursor: pointer;
      }
    }
    .content {
      // height: calc( 100vh - 287px);
      height: calc(100vh - 250px);
      padding-right: 10px;
      // padding-right: 6px;
      overflow-y: auto;
      // height: 617px;
    }
    /deep/ .el-card__header {
      padding: 0;
      margin-bottom: 20px;
      border: none;
    }
    .list-group {
      height: 100%;
    }
    .list-group-item {
      position: relative;
      cursor: pointer;
      line-height: 24px;
      color: #575962;
      background-color: #f1f2f7;
      &.tip {
        // padding-left: 11px;
        &:before {
          // margin-top: 30px;
          display: block;
          content: '';
          width: 6px;
          height: 100%;
          position: absolute;
          left: 0;
          // background:rgba(242,81,81,1);
          border-radius: 4px 0px 0px 4px;
        }
      }
      &.tip.warning {
        &:before {
          background: #f5a623;
        }
      }
      &.tip.rush {
        &:before {
          background: rgba(242, 81, 81, 1);
        }
      }
      .group-item {
        position: relative;
        margin-bottom: 10px;
        padding: 20px;
        padding-bottom: 15px;
        border-radius: 4px;
        &.is-checked:after {
          content: '';
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          background-color: rgba(150, 153, 162, 0.5);
          border-radius: 4px;
        }
        .title-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 16px;
          .flex-row {
            display: flex;
          }
          .title {
            color: $color6;
            // text-decoration: line-through;
          }
        }
        /deep/ .cus-btn-date.el-input {
          .el-input__inner {
            height: 40px;
            line-height: 40px;
          }
        }
      }
      .person-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 24px;
        .time {
          display: inline-block;
          font-size: 13px;
          &.m-danger {
            /deep/ .el-input__inner {
              color: $danger;
            }
          }
        }
        /deep/ .operate {
          display: inline-block;
          white-space: nowrap;
          min-width: 24px;
        }
      }
    }

    .list-group-item.sortable-chosen {
      .group-item {
        background-color: #fff;
        // background-color: $color6;;
        // opacity: .5;
      }
    }

    .list-group-item.sortable-ghost {
      .group-item {
        background-color: #f2f9ff;
      }
    }

    /deep/ .el-checkbox__label {
      display: none;
    }
  }
  .panel-add {
    padding: 0 20px;
    background: #f1f2f7;
    border-radius: 4px;
    line-height: 54px;
    cursor: pointer;
  }
  .task-add-box {
    padding: 10px;
    background-color: #f1f2f7;
    /deep/ .task-area.el-textarea {
      textarea {
        height: 80px;
      }
    }
    h4 {
      font-weight: normal;
      cursor: pointer;
    }
    .cmp-datepicker {
      line-height: 40px;
      /deep/ .cus-btn-date.el-input {
        // width: 100px;
        .el-input__inner {
          height: 40px;
          line-height: 40px;
          // width: 100px;
          // padding-right: 15px;
        }
        // /deep/ .el-input__suffix {
        //   right: 0;
        // }
        // ::-webkit-input-placeholder { /* WebKit browsers */
        //   color: $color5;
        // }
        // :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
        //   color: $color5;
        // }
        // ::-moz-placeholder { /* Mozilla Firefox 19+ */
        //   color: $color5;
        // }
        // :-ms-input-placeholder { /* Internet Explorer 10+ */
        //   color: $color5;
        // }
      }
    }
  }
}
.operate-box {
  h3.dele {
    &:hover {
      color: $danger;
    }
  }
  /deep/ .cus-btn-date.el-date-editor.el-input {
    // width: 150px;
    input {
      background-color: transparent;
      &:focus {
        box-shadow: none;
      }
    }
    .el-input__inner {
      height: 40px;
      line-height: 40px;
      padding-left: 0 !important;
      border: none;
      cursor: pointer;
    }
    .el-input__prefix {
      display: none;
      .el-input__icon {
        color: #0590ff;
      }
    }
  }
}
// .drag {
//   background: #fff;
//   padding-bottom: 40px;
//   &:after {
//     content: "";
//     display: table;
//     clear: both;
//   }
//   .drag-list {
//     float: left;
//     padding-bottom: 30px;
//     &:first-of-type {
//       margin-right: 2%;
//     }
//     .dragArea {
//       margin-top: 15px;
//       min-height: 50px;
//       padding-bottom: 30px;
//     }
//   }
// }

// .list-complete-item {
//   cursor: pointer;
//   position: relative;
//   font-size: 14px;
//   padding: 5px 12px;
//   margin-top: 4px;
//   border: 1px solid #bfcbd9;
//   transition: all 1s;
// }

// .list-complete-item-handle {
//   overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;
//   margin-right: 50px;
// }

// .list-complete-item-handle2 {
//   overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;
//   margin-right: 20px;
// }

// .list-complete-item.sortable-chosen {
//   background: #4AB7BD;
// }

// .list-complete-item.sortable-ghost {
//   background: #30B08F;
// }

// .list-complete-enter,
// .list-complete-leave-active {
//   opacity: 0;
// }
</style>
